module.exports = __webpack_public_path__ + "static/img/2.4ac7631.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/2.png
// module id = pA/0
// module chunks = 0